// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { palmTestnet as _palmTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the palmTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 11297108099
 * Chain Name: Palm Testnet
 * Default Block Explorer: https://palm.chainlens.com
 * Default RPC URL: https://palm-mainnet.public.blastapi.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { palmTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: palmTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const palmTestnet = createCommon({
	..._palmTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
